import { DictionaryLanguageForm as DictionaryLanguageFormDefinition } from "./DictionaryLanguageForm";

export const DictionaryLanguageForm = DictionaryLanguageFormDefinition;
